import { Configuration } from './../conf/app.constants';
import { UIService } from './../ui.service';
import { Injectable } from '@angular/core';
import {
  FileDetailsDTO,
  SignatureDTO,
  DocumentDTO,
  DocumentFileTypeDTO,
  DocumentVersionDTO,
  DocumentStateDTO,
  getSimpleIdentifierFromString
} from '../../app/api/plyca-dtos';
import { PlycaDataService } from '../../services/plyca.service';
import { ServiceLocator } from './../ServiceLocator';
import {
  documentFileViewerComponent,
  ViewDTOModal
} from './../documents/documentFileViewer/documentFileViewer.component';

import {
  validateSignDocumentComponent,
  ViewSignDTOModal
} from './../documents/validateSignDocument/validateSignDocument.component';
import {
  ViewModalHistory,
  documentHistoryComponent
} from './documentHistory/documentHistory.component';
import { TranslateService } from '@ngx-translate/core';
import { HelpService } from '../components/common/help/help.service';
import { documentsComponent } from './documents.component';
import { catchError, finalize, switchMap, take, tap } from 'rxjs/operators';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { Observable } from 'rxjs';
import { BaseDirectiveObject } from '../components/common/base-directive-object';


@Injectable(

)

export class DocumentService extends BaseDirectiveObject {
  public plycaService: PlycaDataService;
  private uiService: UIService;

  documentsLoaded: boolean;

  constructor(
    public dialogService: DialogService,
    private translationService: TranslateService,
    private waitService: WaitLoadingService,
    public configuration: Configuration,
    public helpService: HelpService
  ) {
    super();
    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
    this.uiService = ServiceLocator.injector.get(UIService);
  }

  viewFile(fileItem: FileDetailsDTO, tags?: string[]) {

    let tagsParent: string[];


    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      tap(
        (storedHelpTags) => {
          tagsParent = storedHelpTags;
          if (tags) {
            this.subscribe(this.helpService.showContextHelpObservable(tags));

          }
        }
      )));

    console.log('Intentando visualizar documento');
    let config: DynamicDialogConfig = {
      header: fileItem?.name,
      width: '85%',
      style: { overflow: 'scroll', 'max-height': '90%' },
      styleClass: 'helpStyle'
    };
    config['item'] = new ViewDTOModal(fileItem);

    let ref = this.dialogService.open(documentFileViewerComponent, config);

    this.subscribe(ref.onClose.pipe(
      switchMap(() => this.helpService.showContextHelpObservable(tagsParent))));




  }

  downloadFile(fileItem: FileDetailsDTO) {
    console.log('Método downloadFile');
    this.plycaService.downloadFile(fileItem).pipe(take(1)).subscribe(
      () => {
        console.log('Fichero descargado con éxito');
      },
      err => {
        console.log('Error al descargar fichero');
        console.log(err);
      }
    );
  }

  downloadEmbedded(fileItem: FileDetailsDTO) {
    console.log('Metodo downloadEmbedded');
    this.plycaService.downloadEmbedded(fileItem).pipe(take(1)).subscribe(
      () => {
        console.log('Fichero embedded descargado con exito');
      },
      err => {
        console.log('Error al descargar fichero');
        console.log(err);
      }
    );
  }

  printFile(fileItem: FileDetailsDTO) {
    console.log('Método printFile');
    this.plycaService.printDocument(fileItem).pipe(take(1)).subscribe(
      () => {
        console.log('Imprimir ok');
      },
      err => {
        console.log('Error al imprimir');
        console.log(err);
      }
    );
  }

  viewHistory(document: DocumentDTO) {
    console.log('Intentando visualizar historico de documento');
    let config: DynamicDialogConfig = {
      header: document.name,
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'helpStyle'
    };
    config['item'] = new ViewModalHistory(document.identifier);

    let curentHelpTags = [];
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => curentHelpTags = helpTags)));
    let ref = this.dialogService.open(documentHistoryComponent, config);

    this.subscribe(ref.onClose.pipe(
      switchMap(() => this.helpService.showContextHelpObservable(curentHelpTags))));


  }

  validateSignDocument(signature: SignatureDTO, file: FileDetailsDTO, onAcceptInvalidSignature?: (f: FileDetailsDTO) => void, onRejectInvalidSignature?: (f: FileDetailsDTO) => void) {
    console.log('Intentando visualizar documento');

    let config: DynamicDialogConfig = {
      header: this.translationService.instant('ValidateSignDocument.title'),
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'helpStyle'
    };
    config['item'] = new ViewSignDTOModal(signature, file);
    if (onAcceptInvalidSignature || onRejectInvalidSignature)
      config['askUser'] = true;
    let curentHelpTags = [];
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => curentHelpTags = helpTags)));
    const ref = this.dialogService.open(validateSignDocumentComponent, config);
    this.subscribe(
      ref.onClose, (
      take(1),
      accept => {
        this.subscribe(this.helpService.showContextHelpObservable(curentHelpTags));
        if (accept) {
          if (onAcceptInvalidSignature)
            onAcceptInvalidSignature(file);
        } else {
          if (onRejectInvalidSignature)
            onRejectInvalidSignature(file);
        }
      })
    );
  }

  // public getSignatureDetail(
  //   signature: SignatureDTO
  // ): Observable<SignatureDTO> {
  //   console.log('getSignatureDetail');
  //   let sign: SignatureDTO;
  //   return this.plycaService.getSignatureDetail(signature);
  // }

  public getTypeDocument(
    type: DocumentFileTypeDTO,
    document: DocumentDTO
  ): Array<FileDetailsDTO> {
    return this.getTypeDocumentVersion(type, document.currentVersion);
  }

  public getTypeDocumentVersion(
    type: DocumentFileTypeDTO,
    documentVersion: DocumentVersionDTO
  ): Array<FileDetailsDTO> {
    let filesDetailsDTO: Array<FileDetailsDTO> = [];
    if (documentVersion.files) {
      for (let i = 0; i < documentVersion.files.length; ++i) {
        if (documentVersion.files[i].fileType === type) {
          filesDetailsDTO.push(documentVersion.files[i]);
        }
      }
    }
    return filesDetailsDTO;
  }

  getIconType(fileName: string) {
    let fileExtension = (fileName) ?
      fileName.toUpperCase().substring(fileName.lastIndexOf('.') + 1)
      :
      'none';
    switch (fileExtension) {
      case 'PDF': {
        return 'fa-file-pdf';
      }
      case 'DOC': {
        return 'fa-file-word';
      }
      case 'DOCX': {
        return 'fa-file-word';
      }
      default: {
        return 'fa-file-code';
      }
    }
  }

  public isPdf(fileItem: FileDetailsDTO): boolean {
    return FileDetailsDTO.isPDF(fileItem);
  }

  // Metodo para calcular el estilo de la columna estado en funcion de los datos del documento
  getStatusColor(state: DocumentStateDTO): string {
    let ret = 'badge ';
    try {
      let stateId = getSimpleIdentifierFromString(state.type.identifier);
      if (stateId === 'ANULADO') {
        ret += 'badge-danger';
      } else if (stateId === '1') {
        // 'Cumplimentado') {
        ret += 'badge-secondary';
      } else if (stateId === '2') {
        // 'En reparacion') {
        ret += 'badge-warning';
      } else {
        ret += 'badge-secondary';
      }
      return ret;
    } catch (ex) {
      return '';
    }
  }

  getRejectComment(doc: DocumentDTO): string {
    let comment = '';
    // para calcular el comentario es necesario tener el historico de estados
    if (doc.stateHistory) {
      let currentState = doc.currentState;
      if (currentState.correctionState) {
        let reversedHistory = doc.stateHistory.reverse();
        for (let state of reversedHistory) {
          if (!state.correctionState) {
            if (state.rejectionState) {
              if (state.comment) {
                comment = state.comment;
              } else {
                comment = 'Devolución sin comentarios'
              }
              break;
            } else {
              break;
            }
          }
        }
      }
    }
    return comment;
  }

  openDossierDocumentsDialog(dossierId: string, title?: string, filters?: any, selectionMode?: any,
    selectedDocs?: Array<any>, readonly = false) {
    if (!title) {
      title = dossierId;
    }
    let config: DynamicDialogConfig = {
      header: title,
      width: '90%',
      style: { overflow: 'scroll', 'max-height': '90%' },
      styleClass: 'helpStyle'
    };
    config['id'] = dossierId;
    // Si no llegan filtros, por defecto se exclyen versiones temporales
    if (!filters) {
      filters = {
        avoidTemporaryDocs: false
      }
    }
    config['docFilters'] = filters;
    config['SELECTION_MODE'] = selectionMode;
    config['selectedDocsReadOnly'] = readonly;
    config['isModalWindow'] = true;
    config['selectedDocs'] = selectedDocs;
    let curentHelpTags = [];
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => curentHelpTags = helpTags)));
    let ref = this.dialogService.open(documentsComponent, config);
    this.subscribe(ref.onClose.pipe(
      switchMap(() => this.helpService.showContextHelpObservable(curentHelpTags))));
  }

  // INVOCACION A LA ACCION DE CORREGIR DOCUMENTO
  correctDocument(document: DocumentDTO, comment?: string) {
    //    this.confirmationService.confirm({
    this.uiService.showConfirmMessage({
      message: this.translationService
        .instant('Documents.correct.confirmMsg')
        .replace('#DOC#', document.name),
      accept: () => {
        this.documentsLoaded = false;
        this.waitService.startWaiting();
        return this.plycaService
          .execAction(
            this.configuration.DOCUMENTS_SERVICE_URL,
            document.identifier,
            'CORRECT_DOCUMENT',
            'CORRECT_COMMENT=' + comment
          )
          .pipe(
            take(1),
            catchError(result => {
              this.documentsLoaded = true;
              let msg = this.translationService
                .instant('Documents.correct.error')
                .replace('#DOC#', document.name);
              result.errors.forEach(err => {
                msg += err.message + '<br>';
              });
              this.uiService
                .showMessage(
                  msg,
                  this.translationService.instant('Documents.correct.ok')
                )
                .onClose.pipe(take(1)).subscribe(() => {
                  console.log('CATCHERROR.onclose: wait CANCELED');
                });
              return result;
            }),
            finalize(() => {
              this.waitService.cancelWaiting();
            })
          )
          .subscribe(() => {
            console.log('SUBSCRIBE: wait started');
            this.uiService
              .showMessage(
                this.translationService
                  .instant('Documents.correct.ok')
                  .replace('#DOC#', document.name),
                this.translationService.instant('Ok')
              )
              .onClose.pipe(take(1)).subscribe(

              // () => this.load()

            );
          });
      }
    });
  }

}
